<script setup lang="ts">

import {ActivityLogEntry} from "@hantera/design-system";
import Delivery from "@/components/Order/Deliveries/Delivery.vue";

const props = defineProps<{
  entry: ActivityLogEntry
}>()

</script>

<template>
  <Delivery :delivery="entry.dynamic.delivery" />
</template>

<style scoped>

</style>